import React from 'react'

const generalErrorMessage = (
  <>
    Sorry, we are unable to proceed with your request online. Please contact our Customer Service at{' '}
    <a href="tel:1800889933">1 800 889 933</a> or <a href="tel:+60321707300">+603 2170 7300</a>,
    operating hours 8:30am - 5.00pm (Monday to Friday) excluding public holidays. Alternatively, you
    may email your vehicle details (car plate and NRIC) to{' '}
    <a href="mailto:customer@bsompo.com.my">customer@bsompo.com.my</a> for further assistance.
  </>
)

export default {
  id: 'EN',
  travelBenefits: {
    title: 'Benefits of Secure Travel Insurance',
    desc:
      "From everyday travel inconveniences to unexpected moments along the way, whether at home or abroad, we’ll be there to protect you through it all.",
    benefit1: 'Emergency Medical Evacuation & Repatriation',
    benefit2: 'Fly back and get medical treatment in the comfort of your home country.',
    benefit3: 'Rest and travel easy, even if there are unexpected medical expenses',
    benefit4: 'Unexpected cancellations? Let us figure it out for you!',
    benefit5: 'Support that stays with you during hospital stays on your trip and recovery back in Malaysia.',
    benefit6:
      'Trip interruption coverage or a trip cut short due to emergencies? Worry not, we are here for you.',
  },
  keyCoverage: {
    title: 'Key Coverage',
    desc:
      'Find out the best travel insurance plan below that suits your travelling needs. Get a quote now for full travel insurance coverage.',
    eliteA: 'Elite A',
    eliteB: 'Elite B',
    eliteC: 'Elite C',
    coverage1: 'MEDICAL & OTHER EXPENSES',
    coverage1sub1_1: 'Medical, Hospital',
    coverage1sub1_2: 'Other Expenses',
    coverage1Dropdown1: 'Medical, Hospital & Other Expenses',
    coverage2: 'PERSONAL ACCIDENT',
    coverage2sub1: 'Personal Accident',
    coverage2Dropdown1: 'Permanent Total Disablement',
    coverage3: 'EMERGENCY MEDICAL EVACUATION & REPATRIATION',
    coverage3sub1: 'Emergency Medical Evacuation/Repatriation*',
    coverage3Dropdown1: 'Repatriation of Mortal Remains*',
    coverage4_1: 'TRAVEL INCONVENIENCES & OTHER TRAVEL RELATED BENEFITS',
    coverage4_2: 'Covered',
    coverage4_3: 'Not Covered',
    inclusive: '(Inclusive of COVID-19 Coverages)',
    unlimited: 'Unlimited',
  },
  highlights: {
    travelHighlights: 'Travel Insurance Highlights',
    desc: 'Explore our latest attractions and activities',
    highlight1: 'Travel Insurance Malaysia',
    highlight1desc: 'Ultimate Guide for Travel Insurance',
    highlight2: 'How to Buy Travel Insurance Online',
    hightlight2desc: 'Easy purchase in 6 steps.',
    highlight3: 'SOMPO TravelSafe - Frequently Asked Questions (FAQs)',
    highlight3desc: "Need help? We've got you covered.",
    readMore: 'Read More',
  },
  moreInsurance: {
    title: 'Covering every part of every day',
    desc: 'Learn more about the products we offer',
    more1Title: 'Car Insurance',
    more1Sub1: '0% Interest instalment plan up to 12 months.',
    more1Sub2: 'Complimentary all drivers policy, no nomination is required.',
    more1Sub3_1: 'Online motor insurance renewal',
    more1Sub3_2: 'with instant JPJ status update.',
    more1Sub4: '24 Hours Roadside Assistance.',
    more2Title: 'Motorcycle Insurance',
    more2Sub1: 'Get an instant online quotation in 1 minute.',
    more2Sub2: 'Auto-update to JPJ system once insurance policy has been renewed.',
    more2Sub3: 'Revised pricing with affordable premium rates.',
    more2Sub4: 'Simple purchase journey with 100% safe and secured system.',
    more3Title: 'Hospital Income Insurance',
    more3Sub1: 'Premium as low as RM0.29 per day.',
    more3Sub2: 'COVID-19 coverage with up to RM5,000 lump sum hospital allowance.',
    more3Sub3: 'Daily cash benefit up to a maximum of RM18,000.',
    more3Sub4: 'Hassle-free sign-up process, no health declaration necessary.',
    getQuote: 'Get Quote',
  },
  travelInsurance: {
    title: 'Travel Insurance Malaysia',
    desc1:
      'SOMPO TravelSafe is an outbound overseas and domestic Malaysia travels insurance. We offer comprehensive travel insurance coverage enhanced with COVID-19 benefits for you and your family to protect against any travelling emergencies, travel inconveniences, flight cancellations, flight delays, COVID-19 complications like medical expenses and quarantine allowances, also inclusive of protection of other medical or health complications during your travel so that you can enjoy your holiday with peace of mind.',
    desc2:
      'You can buy SOMPO TravelSafe - travel insurance Malaysia via our online portal in 2 minutes at affordable prices. With a simple phone call, our 24/7 worldwide travel assistance is ready to serve you for any emergencies wherever you are.',
    desc3:
      'Do not risk yourself in any unexpected events, so get a quote and buy travel insurance in Malaysia online before your next trip.',
    title2: 'SOMPO TravelSafe Travel Insurance',
    desc4:
      'The world has reopened, and travelling amidst the COVID-19 pandemic has become the new normal. With SOMPO TravelSafe, you can now travel internationally or domestically with an absolute peace of mind. Enjoy comprehensive travel protection up to RM500,000, and coverage against COVID-19* related complications – all in a single travel insurance that protects your every mile. The world awaits.',
    desc5: '*Only applicable to fully vaccinated travellers.',
  },
  mailQuote: {
    mail: 'Enter an email address below to save or share your quote',
    sendMail: 'Send Email',
    mailQuote2: 'By clicking send, you have read and agreed to our',
    mailQuote3: '',
    privacyNotice: 'Privacy Notice',
    email: 'Email',
    successQuote: 'Your quote has been sent to the email provided.',
    failedQuote: 'An error occured while attempting to send your quotation!',
  },
  elitePlan: {
    foundPlans: 'We found 3 plans that suit you best.',
    eliteA: 'Elite A',
    eliteB: 'Elite B',
    eliteC: 'Elite C',
    totalPrice: 'Total Price for',
    adult: 'Adult',
    adults: 'Adults',
    child: 'Child',
    children: 'Children',
    buyNow: 'Buy Now',
    limitPerPerson: 'Limit Per Person',
    limitPerFamily: 'Limit Per Family',
    upTo70Years: 'Up to 70 years',
    above70Years: 'Above 70 years',
    perDay: 'Per Day',
    perIndividual: 'Per Individual',
    perFamily: 'Per Family',
    perAdult: 'Per Adult',
    perChild: 'Per Child',
    planCoverage1: 'MEDICAL & OTHER EXPENSES',
    coverage1sub1: 'Medical, Hospital & Other Expenses',
    coverage1sub2: 'Alternative Medicine*',
    coverage1sub3_1: 'Compassionate Visitation Care',
    coverage1sub3_2: '(due to Your hospitalisation) *',
    coverage1sub4_1: 'Compassionate Visitation Benefit',
    coverage1sub4_2: '(due to Your death) *',
    coverage1sub5_1: 'Medical Treatment in Malaysia',
    coverage1sub5_2: '* Follow-up treatment within 60 days upon return to Malaysia.',
    coverage1sub6: 'Child Care Benefit*',
    coverage1sub7: 'Hospital Allowance',
    coverage1sub8: 'Overseas Quarantine Allowance Due to COVID-19',
    planCoverage2: 'PERSONAL ACCIDENT',
    coverage2sub1: 'Accidental Death',
    coverage2sub2: 'Permanent Total Disablement',
    coverage2sub3: 'Loss of sight of one or both eyes and/or loss of one or more limbs',
    planCoverage3: 'EMERGENCY MEDICAL EVACUATION & REPATRIATION',
    coverage3sub1: 'Emergency Medical Evacuation/Repatriation',
    coverage3sub2: 'Repatriation of Mortal Remains',
    coverage3sub3:
      '*Maximum limit payable for Emergency Medical Evacuation/Repatriation and Repatriation of Mortal Remains',
    planCoverage4: 'TRAVEL INCONVENIENCES & OTHER TRAVEL RELATED BENEFITS',
    planCoverage5: 'SOMPO SMART DELAY',
    coverage4sub1: 'Loss/Damage of Baggage and Personal Effects',
    coverage4sub2: 'Baggage Delay',
    coverage4sub3: 'Personal Money & Documents',
    coverage4sub4: 'Travel Delay',
    coverage4sub5: 'Travel Re-Route',
    coverage4sub6: 'Loss of Deposit or Cancellation',
    coverage4sub7: 'Travel Curtailment',
    coverage4sub8: 'Travel Overbooked',
    coverage4sub9: 'Travel Misconnection',
    coverage4sub10: 'Hijacking Inconvenience',
    coverage4sub11: 'Missed Departure',
    coverage4sub12: 'Loss of Deposit or Full Payment due to Insolvency of Airlines',
    coverage4sub13: 'Personal Liability',
    inclusiveCoverage: '(Inclusive of COVID-19 Coverages)',
    complimentaryLounge: '(Enjoy complimentary airport lounge access when your flight is delayed)',
    registrationRequired: 'Registration is required after purchase.',
    smartDelayCriteria_1: 'When flight is delayed by',
    smartDelayCriteria_2: 'more than',
    delayCompensation: 'RM200.00 for every 6 full consecutive hours delay',
    overbookedCompensation:
      'RM200.00 for every 6 full consecutive hours for overbooked common air carrier and no alternative transportation is made available.',
    misconnectionCompensation:
      'RM200.00 if no alternative transportation available within 4 hours of the actual arrival time.',
    hijackingCompensation: 'RM1,000.00 for every 24 full consecutive hours of hijack.',
  },
  domesticPlan: {
    foundPlans: 'We found 1 plan that suit you best.',
    domestic: 'Domestic',
    totalPrice: 'Total Price for',
    adult: 'Adult',
    adults: 'Adults',
    child: 'Child',
    children: 'Children',
    buyNow: 'Buy Now',
    limitPerPerson: 'Limit Per Person',
    limitPerFamily: 'Limit Per Family',
    limitPerIndividual: 'Limit Per Individual',
    upTo70Years: 'Up to 70 years',
    above70Years: 'Above 70 years',
    perDay: 'Per Day',
    perIndividual: 'Per Individual',
    perFamily: 'Per Family',
    perAdult: 'Per Adult',
    perChild: 'Per Child',
    planCoverage1: 'MEDICAL & OTHER EXPENSES',
    coverage1sub1: 'Medical, Hospital & Other Expenses',
    coverage1sub2: 'Alternative Medicine*',
    coverage1sub3: 'Hospital Allowance',
    planCoverage2: 'PERSONAL ACCIDENT',
    coverage2sub1: 'Accidental Death',
    coverage2sub2: 'Permanent Total Disablement',
    coverage2sub3: 'Loss of sight of one or both eyes and/or loss of one or more limbs',
    planCoverage3: 'TRAVEL INCONVENIENCES & OTHER TRAVEL RELATED BENEFITS',
    coverage3sub1: 'Loss/Damage of Baggage and Personal Effects',
    coverage3sub2: 'Baggage Delay',
    coverage3sub3: 'Travel Delay',
    coverage3sub4: 'Loss of Deposit or Cancellation',
    coverage3sub5: 'Loss of Deposit or Full Payment due to Insolvency of Airlines',
    inclusiveCoverage: '(Inclusive of COVID-19 Coverages)',
    delayCompensation: 'RM200.00 for every 6 full consecutive hours delay',
  },
  error: {
    fieldRequired: 'This field is required',
    invalidMobile: 'Please enter a valid mobile number',
    tickPolicyCondition: 'Please tick if you meet the above policy condition',
    validEmail: 'Please enter a valid email',
    validCimbEmail: 'Please enter a valid CIMB email',
    validPostcode: 'Invalid postcode',
    invalidNRIC: 'Invalid NRIC',
    nricMustMatchDOB: "NRIC must match with main insured's date of birth",
    secondaryNricMustMatchDOB: "NRIC must match with insured's date of birth",
    duplicateID: 'Duplicate ID found',
    coverAgeBelow: 'We cover ages below 80 years old only',
    coverAgeAbove: 'Policyholder should be age 16 years and above',
    coverAgeChild: 'We cover children up to 23 years old only',
    validUSMEmail: 'Please enter a valid USM email',
    emailNotMatch: 'Emails do not match.',
    remainingPercent: 'Please complete the remaining',
    nomineePercent: 'Nominee percentage does not reach 100%',
    incompleteNominee: 'Please complete the nominee form',
    failedAdd: 'Please add nominee before proceeding',
    amlaError:
      'Sorry, we are unable to proceed with your transaction. Please contact our Customer Service Team at +603 2170 7300 during office hours from Monday to Friday excluding public holidays. Alternatively, you may email us at customer@bsompo.com.my for further assistance.',
    amlaError2: 'Client account is frozen, please contact your marketing superviser.',
    nominationLimit: '2 Maximum limit for nomination only',
    nominationInsuredID: 'Nomination ID and Insured ID cannot be the same',
    nominationIDSame: 'Both Nomination ID cannot be the same',
    nameShortError: 'Name is too short',
    invalidName: 'Please enter a valid name',
    invalidFormat: 'Invalid Format',
  },
  docFilePath: {
    pds_single: '/cimb/securetravel/docs/Secure Travel Single PDS EN Latest.pdf',
    pds_annual: '/cimb/securetravel/docs/Secure Travel Annual PDS EN Latest.pdf',
    pw_single: '/cimb/securetravel/docs/Secure Travel (Single Trip) PW_EN_Latest.pdf',
    pw_annual: '/cimb/securetravel/docs/Secure Travel (Annual) PW_EN_Latest.pdf',
  },
  productLinks: {
    motorNow: 'https://online.berjayasompo.com.my/motorNow/',
    sompoMotor: 'https://online.berjayasompo.com.my/SompoMotor/',
    medicNow: 'https://online.berjayasompo.com.my/medicNow/',
    motorcycle: 'https://online.berjayasompo.com.my/motorcycle/',
    cashNow: 'https://online.berjayasompo.com.my/cashNow/',
    homeNow: 'https://online.berjayasompo.com.my/homeNow/',
    travel: 'https://online.berjayasompo.com.my/securetravel/',
    secureMotor: 'https://online.berjayasompo.com.my/cimb/staff/',
    secureHome: 'https://customer.berjayasompo.com.my/directsales/sh?account_code=10006834#/',
    snatchMedz: 'https://www.berjayasompo.com.my/Snatch/agentIndex?agentid=HQ8180001&product=Medz',
    snatchShield:
      'https://www.berjayasompo.com.my/Snatch/agentIndex?agentid=HQ8180001&product=Shield',
  },
  contact: {
    title: 'Need Help? Contact Us',
    description:
      'If you have any enquiries, please contact Berjaya Sompo Insurance Berhad’s Customer Service Centre at +603 2170 7300 from 8.30 am to 5 pm (Monday to Friday - excluding public holidays) or email customer@bsompo.com.my. Alternatively, you may contact CIMB Bank Berhad at +603 6204 7788, which is available 24 hours, or email contactus@cimb.com.',
    registrationNo: 'Registration No',
  },
  cross_sell: {
    title: 'Covering every part of every day',
    desc: 'Learn more about the insurance products we offer',
    button_01: 'Get Quote',
    button_02: 'Get Quote',
    button_03: 'Get Quote',
    travel_title: 'Travel Insurance',
    travel_01: 'Medical, Hospital & Other Expenses up to RM 500,000.',
    travel_02: 'Overseas Quarantine Allowance Due to COVID-19.',
    travel_03: 'Emergency Medical Evacuation & Repatriation.',
    travel_04: 'Loss of Deposit or Flight Cancellation.',
    snatch_title: 'Snatch Medz+',
    snatch_01: 'Accidental Death up to RM600,000*.',
    snatch_02: 'Double Indemnity due to Snatch Theft or Robbery up to RM1,200,000*.',
    snatch_03: 'Auto Loan Protection Coverage.',
    snatch_04: 'No Claim Renewal Bonus.',
    home_title: 'Secure Home',
    home_01: 'Premium As Low as RM11/Month.',
    home_02: 'All Risk Protection Including Fire, Flood & More.',
    home_03: 'Multiple Plans Option with Up to RM60,000 Coverage.',
    home_04: 'Home Content Declaration is Not Required.',
    securemotor_title: 'Secure Motor',
    securemotor_01: 'Agreed Value',
    securemotor_02: 'Free Special Perils Coverage',
    securemotor_03: 'Coverage for All Drivers',
    securemotor_04: '12 Months Repair Warranty ',
    securemotor_05: '24 Hours Roadside Assistance',
  },
  disclaimer: {
    line_01:
      "Note: You are at Berjaya Sompo Insurance Berhad's website & CIMB Group's privacy policy ceases to apply.",
    line_02: 'Disclaimer',
    line_03:
      'The description of the features and benefits of the insurance product herein is not a contract of insurance and is only a brief summary of the insurance product for quick and easy reference. The complete terms and conditions of the insurance product are contained in the Policy Document of Berjaya Sompo Insurance Berhad, Registration No: 198001008821 (62605-U), the Insurer.',
    line_04:
      'CIMB Bank Berhad ("Bank") accepts no responsibility, obligation or liability for this insurance product and the services provided by the Insurer.',
    line_05: 'The Bank merely acts as a distributor for this insurance product.',
    line_06:
      "This insurance product is Berjaya Sompo Insurance Berhad's product and not a product of the Bank. Therefore this insurance product is not guaranteed by the Bank, its subsidiaries and/or its affiliates and the Insurer shall undertake the full insurance responsibilities, obligations and liabilities in respect of this insurance product.",
  },
  header: {
    cs: 'Berjaya Sompo Customer Service',
    tel: '+603 2170 7300 (8:30 AM - 5:00 PM - Monday to Friday)',
    email: 'customer@bsompo.com.my',
    cs2: 'CIMB Customer Service',
    tel2: '+603 6204 7788 (24 Hours)',
    twentyfourhours: '24 Hours',
    email2: 'contactus@cimb.com',
  },
  footer: {
    title: 'Footer',
    onlineProduct: 'ONLINE PRODUCTS',
    onlineCarIns: 'Online Car Insurance',
    onlineMotorCycleIns: 'Online Motorcycle Insurance',
    onlineTravelIns: 'Online Travel Insurance',
    onlineCashNowIns: 'Online Hospital Income Insurance',
    onlineMedicNowIns: 'Online Medical & Health Insurance',
    onlineHomeNowIns: 'Online Home Content Insurance',
    keyDownload: 'KEY DOWNLOADS',
    pds: 'Product Disclosure Sheet (Single)',
    pwt: 'Policy Wording (Single)',
    pdsAnnual: 'Product Disclosure Sheet (Annual)',
    pwtAnnual: 'Policy Wording (Annual)',
    eBrochure: 'e-Brochure',
    webForm: 'Travel Nomination Web Form',
    contactUs: 'CONTACT US',
    address: 'Address',
    cs: 'Customer Service',
    time: '8:30 AM - 5:00 PM (Monday to Friday)',
    tel1: '1 800 889 933 (within Malaysia)',
    tel2: '+603 2170 7300 (overseas)',
    inMalaysia: 'within Malaysia',
    oversea: 'overseas',
    worldWideAssistance: '24/7 Worldwide Assistance',
    breakDownForPrivateCar: '24/7 Breakdown Service for Private Car',
    breakDownForMotorcycle: '24/7 Breakdown Service for Motorcycle',
    bnm_warning:
      'Please be informed that we will never ask you to provide your personal details online in order to access any product information available on our website. We urge all customers to remain vigilant against online scams.',
  },
  destination: {
    area: 'Area',
    excludeTibetMongolia: 'excluding Tibet and Outer Mongolia',
    areaDesc2: 'Worldwide <strong>excluding</strong> USA &amp; Canada.',
    areaDesc3: 'Worldwide <strong>including</strong> USA &amp; Canada.',
  },
  groupFamilyModal: {
    modalHeader: 'Are you traveling with your friends or family?',
    getQuote: 'Get Quote for',
    familyPlan: 'Family Plan',
    familyPlans: 'Family Plans',
    familyPlanDesc:
      'Covers only immediate family members - Legal spouse and unmarried children, who are aged between 30 days and 18 years old, or up to 23 years old if studying full time.',
    groupPlan: 'Group Plan',
    groupPlans: 'Group Plans',
    groupPlanDesc:
      'Covers all named individuals. Group insured individuals who are aged between 16 and 79 years old for the main insured; 30 days to 79 years old for the second insured onwards.',
  },
  generalErrorMessage: generalErrorMessage,
  errorMessages: [
    {
      apiError: 'general',
      message: generalErrorMessage,
    },
    {
      apiError: 'ISM Connectivity Error',
      message: generalErrorMessage,
    },
    {
      apiError: '[INVALID PERMANENT POST CODE]',
      message: 'Invalid Post Code!',
    },
    {
      apiError: 'UW Policy holder Age Referred',
      message: generalErrorMessage,
    },
    {
      apiError: 'POLICY LAPSED DAYS SHOULD NOT BE MORE THAN 14 DAYS',
      message: generalErrorMessage,
    },
    {
      // TP to comprehensive
      apiError:
        '1 - Scope of Cover changed from Third Party to Comprehensive Referred $$UW Sum Insured Referred',
      message: generalErrorMessage,
    },
    {
      apiError: 'UW Sum Insured Referred',
      message: generalErrorMessage,
    },
    {
      // a case of high perf vehicle got this error
      apiError: 'MAKE MODEL MISSING',
      message: generalErrorMessage,
    },
    {
      apiError: 'sessionExpired',
      message: 'Your session has expired. Please retry from beginning',
    },
    {
      apiError: 'POLICY SHOULD BE LESS THAN 60 DAYS TO TAKE THE EARLIER POLICY',
      message: 'POLICY SHOULD BE LESS THAN 60 DAYS TO TAKE THE EARLIER POLICY',
    },
    {
      apiError: 'INVALID VEHICLE MAKE MODEL',
      message: 'INVALID VEHICLE MAKE MODEL',
    },
    {
      apiError: 'Pricing Field Error',
      message: (
        <>
          We are currently unable to process your quotation. Please try quoting at our alternate
          site at{' '}
          <a href="https://customer.berjayasompo.com.my/directsales/motor-cycle/">
            https://customer.berjayasompo.com.my/directsales/motor-cycle/
          </a>
        </>
      ),
    },
  ],
  travelInsurance: 'Travel Insurance',
  home: 'Home',
  howToClaim: 'How to Claim',
  contactUs: 'Contact Us',
  partnerWithUs: 'Partner With Us',
  faq: 'FAQ',
  faqLink: '/articles/securetravel-faqs',
  homeLink: 'https://online.berjayasompo.com.my/cimb/securetravel/',
  partnerWithUsLink: 'https://travel.berjayasompo.com.my/securetravel/highlights/partner.html',
  onlineProduct: 'Online Products',
  extraCoverage: 'EXTRA COVERAGE FOR POST COVID-19 VACCINATION AT NO COST (NEW)',
  homeBannerWord: 'Resume your travel plans and get protected by our COVID-19 coverage.',
  travellingOverseas: 'Overseas',
  domestic: 'Domestic',
  annual: 'Annual',
  enterDestination: 'Enter all destinations',
  withinMalaysia: 'Within Malaysia',
  depart: 'Depart from Malaysia',
  return: 'Return to Malaysia',
  emailAddress: 'Email Address',
  adult: 'Adult',
  child: 'Child',
  individualGroup: 'Individual / Group / Family',
  travellerTooltip:
    'All individual insured persons aged between 16 years old and 79 years old (both ages inclusive) Group insured person must be age between 16 years old and 79 years old for the main insured; 30 days to 79 years old for the second insured onwards. Minimum 2 insured persons and maximum 20 insured persons travelling on the same journey.',
  getQuote: 'Get Travel Insurance Quote',
  declaration:
    'I am a Malaysian Citizen/Permanent Resident, or holder of a valid working permit, dependant pass or student visa in Malaysia.',
  domesticNotification:
    'For Domestic Travel Plan, coverage for COVID-19 is only applicable for Trips by a scheduled air carrier.',
  tnc: 'By clicking the ‘Get Travel Insurance Quote’ button, you have read and agreed to our',
  tncpn: 'Privacy Notice',
  step1: 'Step 1',
  step2: 'Step 2',
  step3: 'Step 3',
  plan: 'Plan',
  details: 'Details',
  payment: 'Payment',
  buyNow: 'Buy Now',
  viewBenefits: 'View all benefits',
  emailQuote: 'Email quote',
  editQuote: 'Edit quote',
  policyHolderDetails: 'Policyholder Details',
  adultChild: 'Adult / Child',
  fillDetails: 'Please fill in your details below',
  name: 'Name (As per NRIC/Passport)',
  nationality: 'Nationality',
  nricPassport: 'NRIC', // /Passport/Other
  passport: 'Passport',
  passportOther: 'Passport/Other',
  dob: 'Date of Birth',
  malaysianPassport: 'Malaysian Passport (Optional)',
  confirmEmailAddress: 'Confirm Email Address',
  phoneNo: 'Phone No. (010xxxxxxx)',
  address: 'Address',
  address1: 'Address 1',
  address2: 'Address 2',
  postcode: 'Postcode',
  addCity: 'City',
  addState: 'State',
  nomineeDetails: 'Nominee Details (Optional)',
  nominee: 'Nominee',
  nomineeName: "Nominee's name",
  nomineeNRIC: 'NRIC/Passport/Other*',
  nomineeRelationship: 'Relationship',
  nomineePercentage: 'Percentage',
  add: 'Add',
  resetForm: 'Reset',
  quotationSummary: 'Quotation Summary',
  typeOfPlan: 'Type of Plan',
  policyType: 'Policy Type',
  insurancePeriod: 'Period of insurance',
  grossPremium: 'Gross Premium',
  rebate: 'Rebate',
  serviceTax: 'Service Tax',
  grossPremiumAfterRebate: 'Gross Premium After Rebate',
  stampDuty: 'Stamp Duty',
  totalPremium: 'Total Premium',
  commissionToIntermediary: 'Include 25% commission to intermediary',
  summaryPayment: 'Summary & Payment',
  infoConfirmation: 'Please check and confirm the information below',
  paymentDeclaraction1_1: 'I/We have read, understood and acknowledged the ',
  pds: 'Product Disclosure Sheet',
  paymentDeclaraction1_2: ' and ',
  pn: 'Privacy Notice',
  paymentDeclaraction1_3:
    ' and hereby consent to the use and processing of my/our personal data by the Sompo Group of Companies and Berjaya Group of Companies (within or outside Malaysia) for the purposes as described in the Privacy Notice.',
  paymentDeclaraction2:
    'I/We hereby acknowledge that all the information provided are true and I/we have not withheld any information which might influence the acceptance of this proposal. I/We acknowledge that the key contract terms have been adequately explained to me/us and I/we fully understand the terms. I am /we are satisfied that the product meets my/our insurance needs and financial affordability.',
  paymentDeclaraction3:
    'I/We understand that the Product Disclosure Sheet and other product disclosure materials will be provided to me/us in a digital form only.',
  acceptTnC: 'I/We have read and agreed with the Terms & Conditions',
  pleaseAcceptTnC: 'Please accept the terms and conditions',
  marketingConsent:
    'I/We hereby give my consent to Berjaya Sompo Insurance Berhad to share my/our information (excluding information relating to my/our affairs or account) with CIMB Bank Berhad for their marketing and promotion purposes.',
  yes: 'Yes',
  no: 'No',
  tncAgree: 'Please agree to the terms before proceeding',
  onlineBanking: 'Online Banking',
  creditCard: 'Credit Card',
  eWallet: 'eWallet',
  next: 'Next',
  back: 'Back',
  payNow: 'Pay Now',
  paymentSuccess: 'Payment Successful',
  thankYouPayment:
    'Thank you for choosing Secure Travel insurance plan. Your payment has been successfully processed',
  thankyouText1: 'Your policy and receipt will be emailed to',
  thankyouText2: 'Please check your junk/spam folder if you can’t locate them in inbox.',
  registerSD: 'Register/Update Smart Delay',
  registerSDDesc:
    'Register or update your flight details via the Sompo Smart Delay self-service portal by clicking the button above.',
  failedPayment:
    'Thank you for choosing Secure Travel insurance plan. Your payment has not been successfully processed',
  transactionDetails: 'Transaction Details',
  transactionNo: 'Transaction No.',
  transactionDate: 'Transaction Date',
  paymentMethod: 'Payment Method',
  totalAmount: 'Total Amount',
  paymentName: 'Name',
  policyNo: 'Policy No.',
  paymentFailed: 'Payment Failed',
  paymentRetry: 'Payment Re-try',
  periodOfCover: 'Period of Cover',
  to: 'to',
  policyEmailPre:
    'A copy of your receipt and Policy Schedule will be sent to your email address at',
  policyEmailPost:
    "Kindly check your email's junk or spam email folder if you do not receive the documents in your inbox.",
  crossCar: 'https://online.berjayasompo.com.my/cimb/staff/',
  crossCarImage: '/cimb/securetravel/images/img-cross-motor.jpg',
  crossMotor: 'https://online.berjayasompo.com.my/motorcycle/',
  crossMotorImage: '/cimb/securetravel/images/img-cross-motorcycle.jpg',
  crossTravel: 'https://online.berjayasompo.com.my/securetravel/',
  crossTravelImage: '/cimb/securetravel/images/img-cross-travel.jpg',
  crossHome: 'https://customer.berjayasompo.com.my/directsales/sh?account_code=10006834#/',
  crossHomeImage: '/cimb/securetravel/images/img-cross-home.jpg',
  campaignTncText:
    'GrabGifts e-vouchers will be fulfilled via email within 45 days after the campaign ends on 31 December 2023 if you meet the campaign eligibility requirements.',
  downloadCI: 'Download Policy',
  downloadDesc:
    'You may also download the receipt and policy schedule at the download button above. Please take note that the download button link will expire in 15 minutes.',
  downloadDesc2:
    'To open the file, please use the following password format: the first initial of your name (as stated in the policy) in capital letters, followed by the last 6 digits of your NRIC/Passport number.',
  downloadDesc3:
    'For example: If your name is John and the last 6 digits of your NRIC are 141234, your password will be J141234.',
  tinNotFound:
    "Notice: We couldn't find a valid Tax Identification Number (TIN) linked to your details. Therefore, no e-Invoice will be generated for this transaction.",
  consentModalTitle: 'Acknowledgement and Consent',
  readAndAcknowledge_1: 'Please read, understand, and agree to the',
  readAndAcknowledge_2: 'to proceed.',
  agree: 'AGREE',
  minutes: 'minutes',
}
